import {
  Flex, Text, VStack,
} from '@chakra-ui/react';
import { get } from '@submize/lodash';
import { useDispatch } from 'react-redux';
import { setFieldLabelStyles } from '../../formSlice';
import InputSetting from '../../../InputSetting';
import TextStyles from '../../../TextStyles';
import ColorPicker from '../../../ColorPicker/ColorPicker';

const FormLabelStyles = ({ design }) => {
  const dispatch = useDispatch();

  return (
    <VStack color="gray.600" fontSize="sm" gap="3">
      <Text fontWeight="bold">Label</Text>
      <TextStyles
        fontSize={get(design, 'fields.label.size')}
        fontWeight={get(design, 'fields.label.fontWeight')}
        fontStyle={get(design, 'fields.label.fontStyle')}
        color={get(design, 'fields.label.color', get(design, 'textColor'))}
        onChange={(v) => dispatch(setFieldLabelStyles(v))}
      />
      <Flex justify="space-between" w="100%">
        <InputSetting
          label="Margin top"
          value={get(design, 'fields.label.marginTop')}
          onChange={(v) => dispatch(setFieldLabelStyles({ marginTop: v }))}
          regex={/^([0-9]+ ?px)?$/}
          errorMessage="Size must be in px"
        />
      </Flex>
      <Flex justify="space-between" w="100%">
        <InputSetting
          label="Margin bottom"
          value={get(design, 'fields.label.marginBottom')}
          onChange={(v) => dispatch(setFieldLabelStyles({ marginBottom: v }))}
          regex={/^([0-9]+ ?px)?$/}
          errorMessage="Size must be in px"
        />
      </Flex>
      <Flex justify="space-between" w="100%">
        <Text>Required mark</Text>
        <ColorPicker
          color={get(design, 'fields.label.requiredColor', '#C53030')}
          onChange={(v) => dispatch(setFieldLabelStyles({ requiredColor: v }))}
        />
      </Flex>
    </VStack>
  );
};

export default FormLabelStyles;
